// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_3U1CY","cell":"_1k4Pm","imageWrapper":"mzy3t","image":"_3kAWI"};